import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, TextField } from "@mui/material";

const MotivoModal = ({ open, onClose, onSubmit }) => {
  const inputRef = useRef();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (open) {
      setValue(""); // 🔄 limpiar al abrir
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [open]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const trimmed = value.trim();
      if (trimmed !== "") {
        onSubmit(trimmed);
      }
    }
    if (e.key === "Escape") {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <TextField
          inputRef={inputRef}
          label="Motivo de rechazo"
          variant="outlined"
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          size="small"
        />
      </DialogContent>
    </Dialog>
  );
};

export default MotivoModal;
